import React, { lazy, Suspense, useState, useEffect, useCallback } from "react";
import { Container, Row, Col, Image, Button, Modal } from "react-bootstrap";
import htmlParser from "html-react-parser";
import { formatInTimeZone } from "date-fns-tz";
import LeadFormModal from "../LeadModalForm/LeadModal";
import "../Body/Body.css";
import francmob from "../../Images/francmob.webp";
import franctel from "../../Images/franctel.webp";
import francemail from "../../Images/francemail.webp";
import francweb from "../../Images/francweb.webp";
import franclanguage from "../../Images/franclanguage.webp";
import dotmatrix2 from "../../Images/dotmatrix2.png"
import dotmatrix3 from "../../Images/dotmatrixbanner.png"

export default function Body(props) {
  const imgCDNURL = process.env.REACT_APP_BROKERBRK_CDN_URL;
  const [showFormModal, setShowFormModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const handleCloseFormModal = () => setShowFormModal(false);
  const handleShowContactModal = () => setShowContactModal(true);
  const handleApplyNowModal = () => {
    setShowFormModal(true);
  };

  function scrollToSection1() {
    const sectionPosition = document.getElementById("contactusform").offsetTop;
    window.scrollTo({
      top: sectionPosition,
      behavior: "smooth",
    });
  }
  return (
    <>
      <div className="banner">
        <Container>
          <Row>
            <Col>
              <div className="bannertextdesktop ps-2">
            
                <p>
                Your Trusted Real Estate Broker and Loan Originator<br></br>For a Hassle-free Homebuying Experience!
                </p>
              </div>
              <div>
                <img
                  src={imgCDNURL + "mobilefamilyimage.png"}
                  className="mobilefamily img-fluid"
                />
              </div>
              <div>
              <img
                src={dotmatrix2}
                className="dotmatrix2 img-fluid"
              />
              </div>
              <div>
              <img
                src={dotmatrix3}
                className="dotmatrix3 img-fluid"
              />
              </div>
            </Col>
          </Row>
          <Row className="joaquinrow">
            <Col sm={12} md={12} xl={3} lg={3}>
             
              <div className="joaquinsec">
                <img
                  src={imgCDNURL + "edwin-alicea-1.webp"}
                  className="edvin img-fluid"
                />
                <p className="namejoaqu mt-2 mb-2">Franc Marrero</p>
                <p className="namejo2" >
                  License# BK567411 <br></br>Real Estate Sales Professional<br></br>
                  <img src={francmob}/><a style={{textDecoration:'none'}}href="tel:+13212173533">(321) 217-3533</a>{" "}<br></br>
                  <img src={franctel}/><a style={{textDecoration:'none'}}href="tel:+14075304600">(407) 530-4600</a>{" "}<br></br>
                  <img src={francemail}/><a style={{textDecoration:'none'}}href="mailto:franc.marrero@gmail.com">
                    franc.marrero@gmail.com
                  </a>
                  <br></br>
                  <img src={francweb}/><a style={{textDecoration:'none'}}href="http://www.freedompropertyagent.com" target="_blank">
                  http://www.freedompropertyagent.com
                  </a>{" "}
                  <br></br><img src={franclanguage}/>English, Spanish
                  </p>
                <div className="joainfomobile2">
                <p className="namejo1">
                  License# BK567411 <br></br>Real Estate Sales Professional<br></br><br></br>
                  <img src={francmob}/><a style={{textDecoration:'none'}}href="tel:+13212173533">(321) 217-3533</a>{" "}<br></br>
                  <img src={franctel}/><a style={{textDecoration:'none'}}href="tel:+14075304600">(407) 530-4600</a>{" "}<br></br>
                  <img src={francemail}/><a style={{textDecoration:'none'}}href="mailto:franc.marrero@gmail.com">
                    franc.marrero@gmail.com
                  </a>
                  <br></br>
                  <img src={francweb}/><a style={{textDecoration:'none'}} href="http://www.freedompropertyagent.com" target="_blank">
                  http://www.freedompropertyagent.com
                  </a>{" "}
                  <br></br><img src={franclanguage}/>English, Spanish
                    </p>
                  </div>
              </div>
            </Col>
            <Col sm={12} md={12} xl={4} lg={4}>
            <div className="closebuttnmobile">
                  <Button
                    // href="#contactusform"
                    onClick={scrollToSection1}
                    className="contactbutton"
                    // onClick={handleApplyNowModal}
                  >
                    Contact Us
                  </Button>
                </div>
              <div className="introtext">
                <p>
                Hello, my name is Franc Marrero, and I am an experienced Broker with about 39 years experience. Real Estate is my passion and I have helped families to purchase or sell their home. I take pride in being a dedicated and experienced professional committed to providing exceptional service to my clients. With my philosophy of 100% customer satisfaction, I make sure to thoroughly assess my clients’ wants and needs to help them achieve their affordability and goals.
                </p>
                <div className="closebuttn">
                  <Button
                    // href="#contactusform"
                    onClick={scrollToSection1}
                    className="contactbutton"
                    // onClick={handleApplyNowModal}
                  >
                    Contact Us
                  </Button>
                  
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      
      <div className="mortgageofficer">
        As a Real Estate Broker working with Joaquin, I can offer many benefits to my clients!
      </div>
      {/* <div>
        {showFormModal && (
          <LeadFormModal
            showLeadFormModal={showFormModal}
            onHide={handleCloseFormModal}
          />
        )}
      </div> */}
    </>
  );
}
